/**
 * 未入力時の値変換
 */
export const parseEmpty = (parseEmptyValue) => (value) => value === undefined ||
    value === null ||
    (typeof value === 'string' && value === '')
    ? parseEmptyValue
    : value;
